export default __webpack_public_path__ + "static/blob15-d1cdf935f222c0bd2f9f396d7227c99b.svg";